import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

function useUID(): string | undefined {
  const { uid } = useContext(AuthContext);
  return uid;
}

export default useUID;
